import { render, staticRenderFns } from "./FiFileInput.vue?vue&type=template&id=3dd6f995&scoped=true&lang=pug&"
import script from "./FiFileInput.vue?vue&type=script&lang=js&"
export * from "./FiFileInput.vue?vue&type=script&lang=js&"
import style0 from "./FiFileInput.vue?vue&type=style&index=0&id=3dd6f995&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd6f995",
  null
  
)

/* custom blocks */
import block0 from "./FiFileInput.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports